import React from 'react'

const TickIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-Tick_icon">
          <rect width="24" height="24" />
        </clipPath>
      </defs>
      <g id="Tick_icon" data-name="Tick icon" clipPath="url(#clip-Tick_icon)">
        <g id="Group_9013" data-name="Group 9013" transform="translate(2 2)">
          <circle id="Ellipse_353" data-name="Ellipse 353" cx="11" cy="11" r="11" transform="translate(-1 -1)" fill="#8ec750" />
          <path id="Path_18957" data-name="Path 18957" d="M-15073.867,12986.9l2.791,3.1,6.625-6.49" transform="translate(15079.244 -12976.311)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="2" />
        </g>
      </g>
    </svg>
  )
}

export default TickIcon
